import React from "react";
import styles from "./QuestionnaryTextarea.module.scss";

interface QuestionnareTextareaProps {
  label: string;
  name: string;
  isRequired: boolean;
  onChange?: (value: string) => void;
  showErrors?: boolean;
}

const QuestionnareTextarea: React.FC<QuestionnareTextareaProps> = ({ label, name, isRequired, onChange, showErrors = false }) => {
  const [value, setValue] = React.useState("");
  const [isFocused, setIsFocused] = React.useState(false);
  const [error, setError] = React.useState("");
  const [touched, setTouched] = React.useState(false);
  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const validate = (value: string) => {
    let errorMessage = "";
    if (isRequired && value.trim() === "") {
      errorMessage = "Это поле обязательно для заполнения";
    }
    setError(errorMessage);
    return errorMessage === "";
  };

  React.useEffect(() => {
    if (showErrors || touched) {
      validate(value);
    }
  }, [showErrors, touched, value]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    onChange?.(newValue);

    if (error) {
      validate(newValue);
    }
  };

  const handleBlur = () => {
    setTouched(true);
    validate(value);
    setIsFocused(value !== "");
  };

  return (
    <div className={styles.textareaWrapper} ref={wrapperRef}>
      <label className={isFocused ? `${styles.label} ${styles.active}` : styles.label} htmlFor={name}>
        {label} {isRequired && <span>*</span>}
      </label>
      <textarea
        id={name}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onFocus={() => setIsFocused(true)}
        className={`${styles.textarea} ${error && (showErrors || touched) ? styles.invalid : ""}`}
        required={isRequired}
      />
      {(showErrors || touched) && error && <div className={styles.error}>{error}</div>}
    </div>
  );
};

export default QuestionnareTextarea;
